module.exports = __webpack_public_path__ + "media/images/image-51533c39.gif";